import React, { useState } from "react";
import { Record, useRefresh, useTranslate, Confirm } from "react-admin";
import { MenuItem, ListItemIcon, ListItemText } from "@material-ui/core";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import inflection from "inflection";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import { DiagnosticsApiFactory } from "../../../common/data/service-proxies";

interface DeleteRecordMenuItemProps {
  record?: Record;
  resource?: string;
  confirmTitle: string;
  confirmContent: string;
  onClick?: (event: React.MouseEvent) => void;
  hidden?: boolean | ((record: Record) => boolean);
}

const isBoolean = (
  input?: boolean | ((record: Record) => boolean)
): input is boolean => {
  return input === true || input === false;
};

export const AcknowledgeDtcMenuItem = ({
  record,
  resource,
  confirmTitle = "resources.malfunctionsDiag.labels.acknowledge_title",
  confirmContent,
  onClick,
  hidden,
  ...rest
}: DeleteRecordMenuItemProps) => {
  const refresh = useRefresh();
  const translate = useTranslate();
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const axios = useAxiosInstance();

  if (!record) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleAcknowledge = () => {
    if (!axios) {
      return;
    }

    setLoading(true);
    DiagnosticsApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppDiagnosticsAcknowledgeIdPost(Number(record.id))
      .then(() => {
        refresh();
      })
      .catch((e) => console.error(e))
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          setOpen(true);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}>
        <ListItemIcon>
          <DoneAllIcon />
        </ListItemIcon>
        <ListItemText>
          {translate("resources.malfunctionsDiag.labels.acknowledge")}
        </ListItemText>
      </MenuItem>
      <Confirm
        isOpen={isOpen}
        loading={loading}
        title={confirmTitle}
        content={confirmContent}
        translateOptions={{
          name: inflection.singularize(
            translate(`resources.${resource}.forcedCaseName`, {
              smart_count: 1,
              _: inflection.humanize(
                translate(`resources.${resource}.name`, {
                  smart_count: 1,
                  _: inflection.singularize(resource!),
                }),
                true
              ),
            })
          ),
          id: record.id,
        }}
        onConfirm={handleAcknowledge}
        onClose={handleDialogClose}
      />
    </>
  );
};

AcknowledgeDtcMenuItem.defaultProps = {
  confirmTitle: "resources.malfunctionsDiag.labels.acknowledge_title",
  confirmContent: "resources.malfunctionsDiag.labels.acknowledge_content",
  icon: <DoneAllIcon />,
};
